type BillingPeriod = 'day' | 'week' | 'month' | 'year'

const BILLING_PERIODS: BillingPeriod[] = ['day', 'week', 'month', 'year']

const SINGLE_INTERVAL_LABELS: Record<BillingPeriod, string> = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  year: 'Yearly'
}

type BillingCycle = {
  frequency: string | null
  billingPeriod: string | null
  billingInterval: string | null
}

function toCycle({ billingPeriod, billingInterval }: BillingCycle) {
  const period = BILLING_PERIODS.find(p => p === billingPeriod)
  const interval = Number.parseInt(billingInterval ?? '', 10)

  return period && interval ? { period, interval } : null
}

export function formatFrequency(subscription: BillingCycle): string | null {
  const cycle = toCycle(subscription)
  if (!cycle) return subscription.frequency || null

  if (cycle.interval === 1) return SINGLE_INTERVAL_LABELS[cycle.period]

  return `Every ${cycle.interval} ${cycle.period}s`
}
